import { SiteHeader } from "../components/site-header"

export function PricingPage() {
  return (
    <div className="site-frame">
      <SiteHeader />
      <main className="simple-page">
        <div className="eyebrow">Pricing</div>
        <h1>Serious campaign software without the enterprise gate.</h1>
        <p className="docs-intro">
          Start with a site and a small budget. Grow into more campaigns, more automation, team
          workflows, and enterprise controls when the business is ready.
        </p>
        <div className="pricing-grid">
          <section className="price-card">
            <div className="price-card__name">Starter</div>
            <div className="price-card__price">
              $19<span>/month</span>
            </div>
            <p>
              For founders and startups ready to add a site, link accounts, paste the tag, generate
              assets, and launch real Google and Meta campaigns.
            </p>
          </section>
          <section className="price-card price-card--accent">
            <div className="price-card__name">Pro</div>
            <div className="price-card__price">
              $199<span>/month</span>
            </div>
            <p>
              For growing teams scaling more campaigns, creative refreshes, conversion mappings,
              approvals, and automatic optimization.
            </p>
          </section>
          <section className="price-card">
            <div className="price-card__name">Enterprise</div>
            <div className="price-card__price">Custom</div>
            <p>
              For team-managed growth systems with SAML, advanced governance, multi-site workflows,
              and deeper operational controls.
            </p>
          </section>
        </div>
      </main>
    </div>
  )
}
